import {
  Component, OnInit, Input, OnChanges, EventEmitter, Output, OnDestroy
} from '@angular/core';
import { StompService} from '@stomp/ng2-stompjs';
import {ThingsService} from '../../things.service';
import {EventFormService} from '../event-simulation/event-form.service';
import {FormGroup} from '@angular/forms';
import {GlobalService} from '../../../global/global.service';
import {AuthService} from '../../../auth/auth.service';

@Component({
  selector: 'nuc-event-visualization',
  templateUrl: './event-visual.component.html',
  styleUrls: ['./event-visual.component.scss']
})



export class EventVisualComponent implements OnInit, OnChanges, OnDestroy {
  data: Array<any> = [];
  selectedAttributes: Array<any> = [];
  events: Array<any> = [];
  warningOpacity = 0;
  color: Array<any> = ['rgb(223, 64, 120)', '#7B1FA2'];
  form;
  locationForm;
  filterArgs: any = { name: ''};
  isLoading = true;
  firstNonStringAttribute = true ;
  stringType: string;

  @Output() newEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLoaded: EventEmitter<any> = new EventEmitter<any>();
  @Output() hideSimulationWindow: EventEmitter<any> = new EventEmitter<any>();
  @Output() hideSimulateButton: EventEmitter<any> = new EventEmitter<any>();

  @Input() isSimulate = false;
  @Input() schema: any;
  @Input() thing: any;
  option: any;

  chart: any;
  saveInstance(chartInstance): void {
    this.chart = chartInstance;
  }


  constructor( private thingService: ThingsService,
               private evtForm: EventFormService,
               private global: GlobalService,
               private stompService: StompService,
               private authService: AuthService
  ) {
    this.stringType = this.global.DATA_TYPE_STRING;
    this.option  = {
      title: {text: 'Event Data'},
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          month: '%d %b %I:%M:%S %p',
        },
        title: {
          text: 'Event Time'
        }
      },
      yAxis: [],
      tooltip: {
        shared: true
      },
      series: [],
      plotOptions: {
        spline: {
          marker: {
            enabled: true,
          }
        }
      },
      credits: {
        enabled: false
      },

    };
  }

  ngOnInit() {
    this.form = new  FormGroup({});
    this.locationForm = new  FormGroup({});


  }
  ngOnDestroy() {
    this.unSubscribeSocketStream();
    this.thing = null;
  }

  ngOnChanges(...attr: any[]) {
    if (attr[0].thing && attr[0].thing.currentValue.token) {
      this.subscribeForLatestEvent();
      this.getLatestEvents();
    }
    if (attr[0].schema && attr[0].schema.currentValue.id ) {
      this.firstNonStringAttribute = this.getFirstNonStringAttribute();

      if (this.firstNonStringAttribute && !this.selectedAttributes.length && this.events.length) {
        this.selectedAttributes.push(this.firstNonStringAttribute);
        this.initializeGraph();

      }
    }
  }

  getLatestEvents() {


    this.thingService.getThingEvents(this.thing.token, {limit: 10, nonce: new Date().getTime()})
      .subscribe((response) => {response.sort((a, b) => {return a.eventTime - b.eventTime; });
          this.events = response;
          if (this.schema && this.schema.attributes &&
            !this.selectedAttributes.length && this.schema.attributes.length) {
            this.firstNonStringAttribute = this.getFirstNonStringAttribute();

            if (this.firstNonStringAttribute) {
              this.selectedAttributes.push(this.firstNonStringAttribute);
              this.initializeGraph();
            }
            this.buildForm(this.schema);
          }
          this.initializeGraph();
          this.events.length ? '' : this.hideSimulateButton.emit(true);
          this.isLoading = false;
          this.onLoaded.emit(true);

        },
        () => { this.isLoading = false; this.onLoaded.emit(true);  });
  }

  subscribeForLatestEvent() {
    let stomp_subscription;
    this.stompService.state.map((state: number) => state)
      .subscribe(() => {
        this.stompService.publish('/nuke/subscribe',
          JSON.stringify({'deviceList': [this.thing.token]}), {Authorization: `Bearer ${this.authService.getToken()}`}, );
        stomp_subscription = this.stompService.subscribe('/user/queue/events', {Authorization: `Bearer ${this.authService.getToken()}`});
      });


    stomp_subscription.map((message) => {
      return message.body;
    }).subscribe((msg_body: string) => {
      this.onNewEvent(JSON.parse(msg_body));

    });
  }

  onNewEvent(event) {
    let isLimitExceed;
    if (!this.thing || this.thing.token !== event.deviceId) {
      return;
    }
    event.eventTime = event.timestamp;
    this.events.push(event);
    if (this.events.length > 15) {
      this.events.splice(0, 1);
      isLimitExceed = true;

    }
    if (!this.selectedAttributes.length || !this.chart) {
      this.firstNonStringAttribute = this.getFirstNonStringAttribute();
      if (this.firstNonStringAttribute && !this.selectedAttributes.length) {
        this.selectedAttributes.push(this.firstNonStringAttribute);
      }
      this.initializeGraph();
    } else {
      this.updateGraph(event, isLimitExceed);
    }
    this.newEvent.emit(event);
  }

  isSelectedAttribute(attribute) {
    let attr = this.selectedAttributes.filter((attrib) => attribute.name === attrib.name);
    return attr.length > 0;
  }

  updateFilterArgs (args) {
    this.filterArgs = { name: args};
  }


  changeAttributeCheckboxState (attribute, attr, text) {
    this.clearFilter(text);
    this.warningOpacity = 0;
    if (attr.checked) {
      if (this.selectedAttributes.length === 2) {
        this.warningOpacity = 1;
        attr.checked = false;
        return;
      }
      this.addAttribute(attribute);
    } else {
      this.removeAttribute(attribute);
    }

  }

  showSimulateWindow (text) {
    this.isSimulate = true;
    this.clearFilter(text);
  }
  removeAttribute (attribute) {
    const index = this.selectedAttributes.indexOf(attribute);
    this.selectedAttributes.splice(index, 1);
    this.chart ? this.removeAllAxis() : '';
    this.selectedAttributes.forEach((item, itemIndex) => {
      this.chart.addAxis(this.getYAxisData(item, itemIndex));
      this.chart.addSeries(this.getSeriesData(item, this.events, itemIndex));
    });

  }
  buildForm (schema) {
    this.form = this.evtForm.toFormGroup(schema.attributes);
    this.locationForm = this.evtForm.locationToForm(schema.location);
  }

  hideSimulation (event) {
    this.isSimulate = false;
    this.hideSimulationWindow.emit(event);
  }

  clearFilter (text) {
    this.filterArgs.name = '';
    if (text) {
      text.value = '';
    }

  }

  isEmptyStateVisible () {
    return !this.selectedAttributes.length || !this.events.length;
  }

  private addAttribute(attribute) {
    this.selectedAttributes.push(attribute);
    if (this.selectedAttributes.length === 1) {
      this.chart = null;
      this.initializeGraph();
      return;
    }
    this.chart ? this.chart.addAxis(this.getYAxisData(attribute, this.selectedAttributes.length-1)) :'';
    this.chart ? this.chart.addSeries(this.getSeriesData(attribute, this.events, this.selectedAttributes.length - 1)): '';
  }

  private updateGraph(event, isLimitExceed){
    this.selectedAttributes.forEach((item, index) => {
      if (event['attributes'])  {
        let evtData = [event.timestamp, parseFloat(event['attributes'][item.name])];
        if (isLimitExceed) {
          this.chart.series[index].data[0].remove(false, false);
        }
        if (isNaN(evtData[1]) && item.datatype === this.global.DATA_TYPE_BOOLEAN) {
          evtData[1] = event['attributes'][item.name] ? 1 : 0;
        }
        this.chart.series[index].addPoint(evtData);
      }
    });

  }

  private initializeGraph() {
    if (!this.selectedAttributes.length) {
      return;
    }

    if (this.chart) {
      this.selectedAttributes.forEach( (attribute, index) => {
        let data = this.getSeriesData(attribute, this.events, index);
        this.chart.yAxis.length ? this.chart.yAxis[index].update(this.getYAxisData(attribute, index)) :
          this.chart.yAxis.push(this.getYAxisData(attribute, index));
        this.chart.series.length ? this.chart.series[index].update(data) : this.chart.addSeries(data);
      })

    }
    this.option.yAxis = [];
    this.option.series = [];
    this.selectedAttributes.forEach( (attribute, index) => {
      this.option.yAxis.push(this.getYAxisData(attribute, index));
      this.option.series.push(this.getSeriesData(attribute, this.events, index));
    });
  }

  private removeAllAxis() {
    while (this.chart.yAxis.length > 0) {
      this.chart.yAxis[0].remove();
    }

    while (this.chart.series.length > 0) {
      this.chart.series[0].remove();
    }
  }


  private getFirstNonStringAttribute() {
    return this.schema && this.schema.attributes ?  this.schema.attributes.filter(
      (attrib) => attrib.datatype !== this.global.DATA_TYPE_STRING)[0] : null
  }

  private unSubscribeSocketStream() {
    this.stompService.publish('/nuke/unsubscribe',
      JSON.stringify({'deviceList': [this.thing.token]}), {Authorization: `Bearer ${this.authService.getToken()}`});
  }

  private getYAxisData(item, index) {
    return { // Primary yAxis
      gridLineWidth: 1,
      title: {
        text: `${item.name} (${item.unit})`,
        style: {
          color: this.color[index]
        }
      },
      labels: {
        format: '{value} ' + item.unit,
        style: {
          color: this.color[index]
        }

      },
      opposite: index === 1

    };
  }


  private getSeriesData(item, events, axis?) {
    let evtData = {
      name: item.name,
      type: 'spline',
      color: this.color[axis],
      yAxis: axis,
      data: [],
      tooltip: {
        valueSuffix: item.unit,
        xDateFormat: '%d %b %I:%M:%S %p',
      }};
    events.sort((a, b) => a.eventTime - b.eventTime);
    events.forEach((data) => {
      let coordinate = [data.eventTime, parseFloat(data.attributes[item.name])];
      if (item.datatype === this.global.DATA_TYPE_BOOLEAN) {
        coordinate[1] = data.attributes[item.name] ? 1 : 0;
      }
      evtData.data.push(coordinate);
    });

    return evtData;
  }

}



// WEBPACK FOOTER //
// ./src/app/things/things-details/event-visual/event-visual.component.ts